import React from 'react'

interface ContactCardAttachmentProps {
  attachment: {
    id: string
    url: string
    filename?: string
    mime_type?: string
  }
}

const ContactCardAttachment: React.FC<ContactCardAttachmentProps> = ({
  attachment,
}) => {
  return (
    <div
      className="d-flex align-items-center p-3 rounded-xl"
      style={{
        background: 'linear-gradient(135deg, #007bff15, #007bff08)',
        border: '1px solid #007bff30',
        minWidth: '240px',
        maxWidth: '320px',
      }}
    >
      <div
        className="d-flex align-items-center justify-content-center rounded-circle me-3"
        style={{
          width: '48px',
          height: '48px',
          background: 'linear-gradient(135deg, #007bff, #0056b3)',
          color: 'white',
          flexShrink: 0,
          boxShadow: '0 2px 8px rgba(0,123,255,0.3)',
        }}
      >
        <ion-icon name="person" style={{ fontSize: '22px' }} />
      </div>
      <div className="flex-grow-1 min-w-0">
        <div
          className="d-flex align-items-center mb-1"
          style={{
            fontSize: '14px',
            fontWeight: '600',
            color: '#007bff',
          }}
        >
          <span>Contact Card</span>
          <span
            className="badge bg-primary bg-opacity-75 ms-2"
            style={{ fontSize: '9px' }}
          >
            vCard
          </span>
        </div>
        <div
          className="text-truncate"
          style={{
            fontSize: '12px',
            opacity: 0.8,
            marginBottom: '2px',
          }}
        >
          {attachment.filename?.replace(/\.(vcf|vcard)$/i, '') || 'Contact'}
        </div>
      </div>
      <ion-icon
        name="person"
        style={{
          fontSize: '20px',
          color: '#007bff',
          opacity: 0.7,
          flexShrink: 0,
        }}
      />
    </div>
  )
}

export default ContactCardAttachment
